import { QUERY_PROGRESS_PENDING } from "core/consts";
import { FileHISStateful, FileTableActions, QueryProgress } from "core/types";
import GeneralTable from "ds_legacy/components/Tables/GeneralTable";
import {
  COLUMN_TYPE_FILES_CATEGORY,
  COLUMN_TYPE_FILES_FILE_NAME,
  COLUMN_TYPE_FILES_UNAVAILABLE_REASON,
} from "ds_legacy/components/Tables/GeneralTable/CustomCells";
import { EmptyV2 } from "ds_legacy/components/Tables/GeneralTable/EmptyComponent";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { getFileNameAndIsNewVersionAvailable } from "dsl/ecosystems/PatientFiles/utils";
import { FilesTableTitle } from "dsl/organisms/FileTables";
import { useTranslations } from "translations";

export type UnavailableFilesProps = {
  files?: FileHISStateful[] | null;
  isMessenger?: boolean;
  queryProgress: QueryProgress;
};

export function UnavailableFiles({
  files,
  isMessenger,
  queryProgress,
}: UnavailableFilesProps) {
  const translations = useTranslations();

  return (
    <VerticalLayout>
      <FilesTableTitle
        description={
          translations.fileSection.fileListComponent.descriptionFilesUnsupported
        }
        numberOfFiles={files?.length ?? 0}
        title={translations.fileSection.fileListComponent.titleFilesUnsupported}
      />
      <GeneralTable<FileHISStateful, FileTableActions>
        columns={[
          {
            getProps: ({ document_category_number }) => ({
              category: document_category_number,
            }),
            title: translations.fileSection.fileListComponent.category,
            type: COLUMN_TYPE_FILES_CATEGORY,
            width: "10%",
          },
          {
            getProps: (file) =>
              getFileNameAndIsNewVersionAvailable({
                canAccessPatientData: true,
                file,
              }),
            title: translations.fileSection.fileListComponent.fileName,
            type: COLUMN_TYPE_FILES_FILE_NAME,
            width: "65%",
          },
          {
            getProps: "unavailable_reason",
            title: translations.fileSection.fileListComponent.fileErrorReason,
            type: COLUMN_TYPE_FILES_UNAVAILABLE_REASON,
            width: "25%",
          },
        ]}
        data={files || []}
        emptyComponent={
          <EmptyV2
            isMessenger={isMessenger}
            title={
              translations.fileSection.fileListComponent
                .placeholderNothingUploaded
            }
          />
        }
        id="unavailable-files"
        isLoading={queryProgress === QUERY_PROGRESS_PENDING}
      />
    </VerticalLayout>
  );
}
export default UnavailableFiles;
